import React from 'react'
import PropTypes from 'prop-types'
import { DynamicTextarea } from './DynamicTextarea'

import './style.css.scss'

const Title = React.memo(props => {

  const handleTitleChange = title => {
    props.onChange({ title })
  }

  return (
    <div className='article-title'>
      { props.readOnly
        ? <div className="title-container">{props.title}</div>
        : <DynamicTextarea
            value={props.title}
            onChange={handleTitleChange}
            readOnly={props.readOnly} />
      }
    </div>
  )
})

Title.propTypes = {
  title: PropTypes.string,
  onChange: PropTypes.func
}

Title.defaultProps = {
  title: ""
}

export default Title